import "reflect-metadata";
import { injectable, inject } from "inversify";
import { DIMixins } from "@/core/@types/types";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { IUsuarioAdminValidator } from "./IUsuarioAdminValidator";

@injectable()
export default class UsuarioAdminValidator implements IUsuarioAdminValidator {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  handle(): boolean {
    const storage = this.userProfileMixin.handleGetUserProfile();
    const perfil = storage?.PerfilAdm;

    if (!perfil) return false;

    return true;
  }
}
